module.exports = __webpack_public_path__ + "img/newsdetails9.10e88808.png";